// extracted by css-extract-rspack-plugin
export default {"alert":"alert-ivdFTu"};